'use strict';
incomeStatementController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'reportHelper',
	'unitService',
	'accountStructureService',
	'BUSY_MESSAGE',
];
angular.module('schoolLinqApp').controller('incomeStatementController', incomeStatementController);

function incomeStatementController($scope, $rootScope, $q, $interval, reportHelper, unitService, accountStructureService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	if ($rootScope.mode && $rootScope.mode === 'nutrition') {
		$scope.vm.isNutrition = true;
		$scope.vm.fundMenuSection = 'NutritionReports';
		$scope.vm.sectiontitle = 'School Nutrition Income Statement';
	}

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([LoadFiscalYears($scope.vm), LoadFiscalMonths($scope.vm), LoadAccountStructures($scope.vm)]);

	function getViewModel() {
		var model = {
			isNutrition: false,
			fundMenuSection: 'AccountsReports',
			sectiontitle: 'Income Statement',
			fiscalMonths: [],
			lastFiscalMonth: null,
			fiscalYears: [],
			unifiedElementMap: null,
			unifiedAccountMask: null,
			showInclude13thMonth: false,
			report: {
				fiscalYear: null,
				fiscalMonth: 0,
				thirteenthMonthOnly: false,
				includeThirteenthMonth: false,
				includeAccountDetail: false,
				includeBudgetDetail: true,
			},
			message: BUSY_MESSAGE.Loading,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (!model.report.fiscalYear) {
				model.validationErrors.push('Please select a Fiscal Year.');
				isValid = false;
			}

			if (!model.report.monthName && model.report.thirteenthMonthOnly !== true) {
				model.validationErrors.push('Please select a Month.');
				isValid = false;
			}

			if (model.unifiedElementMap) {
				for (var idx = 0; idx < model.report.accountFiltersGrid.length; idx++) {
					var acctF = model.report.accountFiltersGrid[idx];

					if (!acctF.fromValue) {
						model.validationErrors.push("Element: '" + acctF.element + "' must have a From value!");
						isValid = false;
					} else {
						if (!acctF.toValue) {
							acctF.toValue = acctF.fromValue;
						}

						if (parseInt(acctF.fromValue) > parseInt(acctF.toValue)) {
							model.validationErrors.push("Element: '" + acctF.element + "' has an invalid range!");
							isValid = false;
						}
					}
				}
			}

			return isValid;
		}

		function openReport(model) {
			if (!validateReportParams(model)) return false;

			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			let elementRangeParams = [];

			if (model.unifiedElementMap) {
				angular.forEach(model.report.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						elementRangeParams.push(acctF);
					}
				});
			} else {
				angular.forEach(model.report.accountFiltersType, function (acctF) {
					angular.forEach(acctF.queries, function (query) {
						if (query.QueryOption && query.Value) {
							var paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.toValue = parseInt(-1);
							elementRangeParams.push(paramModel);
						}
					});
				});
			}

			var report = {
				FiscalYear: model.report.fiscalYear,
				FiscalMonth: model.fiscalMonths.indexOf(model.report.monthName) + 1,
				MonthName: model.report.monthName,
				ThirteenthMonthOnly: model.report.thirteenthMonthOnly,
				IncludeThirteenthMonth: model.report.includeThirteenthMonth,
				IncludeAccountDetail: model.report.includeAccountDetail,
				IncludeBudgetDetail: model.report.includeBudgetDetail,
				IsNutrition: model.isNutrition,
				ElementRangeModelCol: elementRangeParams,
			};

			reportHelper.getReport($scope, '/api/fundreports/incomestatementreport', report, 'IncomeStatementReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) return false;

			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			let elementRangeParams = [];

			if (model.unifiedElementMap) {
				angular.forEach(model.report.accountFiltersGrid, function (acctF) {
					if (acctF.fromValue && acctF.fromValue.length > 0) {
						elementRangeParams.push(acctF);
					}
				});
			} else {
				angular.forEach(model.report.accountFiltersType, function (acctF) {
					angular.forEach(acctF.queries, function (query) {
						if (query.QueryOption && query.Value) {
							var paramModel = {
								element: '',
								maxLength: 0,
								maxValue: 0,
								fromValue: 0,
								toValue: 0,
								accountTypeId: 0,
								startIndex: 0,
								queryOption: '',
							};

							paramModel.queryOption = query.QueryOption;
							paramModel.fromValue = parseInt(query.Value);
							paramModel.toValue = parseInt(-1);
							elementRangeParams.push(paramModel);
						}
					});
				});
			}

			var report = {
				FiscalYear: model.report.fiscalYear,
				FiscalMonth: model.fiscalMonths.indexOf(model.report.monthName) + 1,
				MonthName: model.report.monthName,
				ThirteenthMonthOnly: model.report.thirteenthMonthOnly,
				IncludeThirteenthMonth: model.report.includeThirteenthMonth,
				IncludeAccountDetail: model.report.includeAccountDetail,
				IncludeBudgetDetail: model.report.includeBudgetDetail,
				IsNutrition: model.isNutrition,
				ElementRangeModelCol: elementRangeParams,
			};

			reportHelper.getExcel($scope, '/api/fundreports/incomestatementexcel', report, 'IncomeStatement.xlsx');
		}

		function fiscalMonthSelected(model) {
			// Only show Include 13th Month if the selected month is the last Fiscal Month
			if (model.report.monthName === model.lastFiscalMonth) model.showInclude13thMonth = true;
			else model.showInclude13thMonth = false;
		}

		function thirteenthMonthOnlySelected(model) {
			if (model.report.thirteenthMonthOnly) {
				model.showInclude13thMonth = false;
				model.report.includeThirteenthMonth = false;
				model.report.monthName = model.fiscalMonths[model.fiscalMonths.length - 1];
			} else {
				// Only show Include 13th Month if the selected month is the last Fiscal Month
				if (model.report.monthName === model.lastFiscalMonth) model.showInclude13thMonth = true;
				else model.showInclude13thMonth = false;
			}
		}

		return angular.extend(model, {
			fiscalMonthSelected: _.partial(fiscalMonthSelected, model),
			thirteenthMonthOnlySelected: _.partial(thirteenthMonthOnlySelected, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}

	function LoadAccountStructures(model) {
		return accountStructureService.getStructure().then(_.partial(finishLoadingStructure, model));

		function finishLoadingStructure(model, response) {
			model.accountStructure = response.data.accountStructure;
			model.unifiedElementMap = response.data.accountStructure.UnifiedElementMap;
			model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
			model.unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;

			return angular.noop;
		}
	}

	function LoadFiscalYears(model) {
		$scope.loadingPromise = unitService.getFiscalYears().then(_.partial(finishLoadingYears, model));

		function finishLoadingYears(model, response) {
			model.fiscalYears = response.data.fiscalYears;
			model.report.fiscalYear = response.data.currentFiscalYear;
			return angular.noop;
		}
	}

	function LoadFiscalMonths(model) {
		$scope.loadingPromise = unitService.getFiscalMonths().then(_.partial(finishLoadingMonths, model));

		function finishLoadingMonths(model, response) {
			model.fiscalMonths = response.data.fiscalMonths;
			model.lastFiscalMonth = model.fiscalMonths[model.fiscalMonths.length - 1];
			model.report.monthName = moment().format('MMMM');
			return angular.noop;
		}
	}
}
